import { ADD_HAZARD_QUESTION_RESPONSE, SAVE_HAZARD_ACCESS_RESPONSE, REMOVE_HAZARD_QUESTION_RESPONSE, SAVE_GET_HAZARD_API_RESPONSE, SAVE_HHSRS_ASSESSMENT_COMPLETED, SAVE_POST_HAZARD_ASSESSMENT_RESPONSE, SAVE_PRE_ASSESSMENT_OUTCOME, SAVE_PRE_ASSESSMENT_QUESTIONS_RESPONSE, SAVE_PRE_ASSESSMENT_RETURN_QUESTION, UPDATE_HAZARD_QUESTION_RESPONSE, HAS_ACTIVE_HAZARD_CASE, SAVE_HAZARD_VALUES, SAVE_ACTIVE_HAZARD_CASE } from "../actionTypes";

export const saveHazardPostAssessmentResponse = (payload: any) => ({
    type: SAVE_POST_HAZARD_ASSESSMENT_RESPONSE,
    payload,
});

export const resetHazardAssessmentData = (payload?: any) => ({
    type: REMOVE_HAZARD_QUESTION_RESPONSE,
    payload
});

export const updateHazardAssessmentAnswer = (payload: any) => ({
    type: UPDATE_HAZARD_QUESTION_RESPONSE,
    payload
});

export const addHazardAssessmentAnswer = (payload: any) => ({
    type: ADD_HAZARD_QUESTION_RESPONSE,
    payload
})

export const saveHazardGetQuestionsData = (payload: any) => ({
    type: SAVE_GET_HAZARD_API_RESPONSE,
    payload
})
export const savePreAssessmentReturnQuestion = (payload: any) => ({
    type: SAVE_PRE_ASSESSMENT_RETURN_QUESTION,
    payload
})
export const savePreAssessmentQuestionsData = (payload: any) => ({
    type: SAVE_PRE_ASSESSMENT_QUESTIONS_RESPONSE,
    payload
})

export const savePreAssessmentOutcome = (payload: string) => ({
    type: SAVE_PRE_ASSESSMENT_OUTCOME,
    payload
})


export const saveHHSRSAssessmentCompleted = (payload: boolean) => ({
    type: SAVE_HHSRS_ASSESSMENT_COMPLETED,
    payload,
});

export const saveHazardAccessResponse = (payload: any) => ({
    type: SAVE_HAZARD_ACCESS_RESPONSE,
    payload
})
export const SavehasActiveHazardCase = (payload: any) => ({
    type: HAS_ACTIVE_HAZARD_CASE,
    payload,
});

export const SaveHazardValues = (payload: any) => ({
    type: SAVE_HAZARD_VALUES,
    payload,
});

export const saveActiveHazardCaseDetails = (payload: any) => ({
    type: SAVE_ACTIVE_HAZARD_CASE,
    payload,
});